import { DocumentsStep } from "Components/Onboarding/NaturalPerson/Steps/DocumentsStep/DocumentsStep";
import { FinalStep } from "Components/Onboarding/NaturalPerson/Steps/FinalStep/FinalStep";
import { PersonalInformationStep } from "Components/Onboarding/NaturalPerson/Steps/PersonalInformationStep/PersonalInformationStep";
import { HandleStep } from "Components/Onboarding/shared/HandleStep/HandleStep";
import type { FC } from "react";

type StepComponent = FC<{ onNextStepRequested: () => void }>;

export enum OnboardingSteps {
  Document = 0,
  PersonalInformation = 1,
  Handle = 2,
  FinalStep = 3,
}

export const STEP_TO_CONTENT: Record<OnboardingSteps, StepComponent> = {
  [OnboardingSteps.Document]: DocumentsStep,
  [OnboardingSteps.PersonalInformation]: PersonalInformationStep,
  [OnboardingSteps.Handle]: HandleStep,
  [OnboardingSteps.FinalStep]: FinalStep,
};
